export default __webpack_public_path__ + "static/media/blob2.4216160a.svg";